import {
    GATEWAY_DEMO_URL,
    GATEWAY_DEV_URL,
    GATEWAY_TEST_URL,
    WP_BASE_DEMO_URL,
    WP_BASE_DEV_URL,
    WP_BASE_TEST_URL,
} from '@eventr/common'
import { reactAppStage } from '../../utils/reactAppStage'

export const gatewayConfig = () => {
    switch (reactAppStage()) {
        case 'dev':
            return {
                baseUrl: GATEWAY_DEV_URL,
                baseWPUrl: WP_BASE_DEV_URL,
            }
        case 'test':
            return {
                baseUrl: GATEWAY_TEST_URL,
                baseWPUrl: WP_BASE_TEST_URL,
            }
        case 'demo':
            return {
                baseUrl: GATEWAY_DEMO_URL,
                baseWPUrl: WP_BASE_DEMO_URL,
            }
        case 'local':
            return {
                baseUrl: 'http://localhost:5000/api/',
                baseWPUrl: 'http://localhost:4300/',
            }
        default:
            return {
                baseUrl: GATEWAY_DEMO_URL,
                baseWPUrl: WP_BASE_DEMO_URL,
            }
    }
}
